export const adminTabs = [
	{
		key: "segmentation",
		label: "Tamanho do Cliente",
		permission: "Pacto Admin.TamanhoCliente"
	},
	{
		key: "variluxGoals",
		label: "Metas de Varilux",
		permission: "Pacto Admin.MetasVarilux"
	},
	{
		key: "netSalesGoals",
		label: "Metas de Net Sales",
		permission: "Pacto Admin.MetasNetSales"
	},
	{
		key: "penalties",
		label: "Penalidades",
		permission: "Pacto Admin.Penalidades"
	},
	{
		key: "adjustment",
		label: "Reajuste",
		permission: "Pacto Admin.Reajuste"
	},
	{
		key: "pactoRebatesParameters",
		label: "Parâmetros do Pacto Rebates",
		permission: "Pacto Admin.ParametrosPactoRebates"
	},
	{
		key: "holidayManagement",
		label: "Feriados",
		permission: "Pacto Admin.Feriados"
	}
];